import React from "react"
import { Link } from "gatsby"
import Layout from "../../components/Layout"
import Pagetitle from "../../components/Pagetitle"
import Seo from "../../components/Seo"
import RelatedPlatforms from "../../components/RelatedPlatforms"
import { PLATFORM_GUIDE_OG_IMAGE } from "../../data/platforms"

const GooglePage = () => (
  <Layout>
    <Seo
      title="Adding your feed to Google Merchant Center"
      description="Step-by-step instructions for adding your Upfeed product feed to Google Merchant Center to run Shopping Ads and Performance Max campaigns."
      image={PLATFORM_GUIDE_OG_IMAGE}
    />
    <div className="container">
      <div className="row justify-content-center">
        <div className="getting-started col-md-8">
          <Link to="/getting-started/#platforms" className="back-link">
            ← All platforms
          </Link>
          <Pagetitle>Adding your feed to Google Merchant Center</Pagetitle>
          <p>
            Follow these steps to connect your UpFeed product feed to Google
            Merchant Center so you can run Shopping Ads and Performance Max
            campaigns.
          </p>

          <div className="prerequisites">
            <p>Before you start, make sure you have:</p>
            <ul>
              <li>
                <Link to="/getting-started/#generate">
                  Generated your product feed
                </Link>{" "}
                and copied the feed URL from the app homepage.
              </li>
              <li>
                <Link to="/getting-started/#googlecats">
                  Set your Google Product Categories
                </Link>{" "}
                — required for Google.
              </li>
              <li>A verified Google Merchant Center account.</li>
            </ul>
          </div>

          <h2>Adding the feed to Google Merchant Center</h2>
          <ul>
            <li>
              In the left menu under 'Products' go to 'Feeds' and click the
              blue plus-button to add a primary feed.
            </li>
            <li>
              Select your country, language and feed destinations, then click
              Continue.
            </li>
            <li>
              On the next page, set a feed name and select 'Scheduled fetch'.
            </li>
            <li>
              Enter a file name such as 'Upfeed Product Feed', set the schedule
              to 'Daily' at 5am New York Time, and enter your feed URL
              (https://www.upfeed.app/feeds/yourstore-feed.csv).
              <br />
              Note: you don't need to set a username or password.
            </li>
            <li>Click the 'Create feed' button.</li>
          </ul>

          <h2>Running Shopping Ads</h2>
          <p>
            After your feed is approved in Merchant Center, link it to your
            Google Ads account. Create a Shopping or Performance Max campaign in
            Google Ads and select your Merchant Center account to start serving
            product ads across Google Search, Shopping, YouTube, and Display.
          </p>

          <RelatedPlatforms currentSlug="google" />
        </div>
      </div>
    </div>
  </Layout>
)

export default GooglePage
